import NumberedListIcon from "../../../../assets/svg/numbered-list-icon";
import StrikeThroughIcon from "../../../../assets/svg/strikethrough-icon";
import UnorderedListIcon from "../../../../assets/svg/unordered-list-icon";
import AlignCenterIcon from "../../../../assets/svg/v1/align-center-icon";
import AlignLeftIcon from "../../../../assets/svg/v1/align-left-icon";
import AlignRightIcon from "../../../../assets/svg/v1/align-right-icon";
import QuoteIcon from "../../../../assets/svg/v1/quote-icon";
import RemoveStyleIcon from "../../../../assets/svg/v1/remove-style-icon";
import { ToolbarSchema } from "../types/types";

export const defaultToolbarSchema: ToolbarSchema = {
  history: true,
  typography: {
    fontFamily: true,
    fontSize: true,
  },
  textFormatting: {
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
  },
  textStyling: {
    textColor: true,
  },
  contentStructure: {
    lists: true,
    alignment: true,
    indentation: true,
    blockquotes: true,
  },
  media: {
    links: true,
    images: true,
    attachments: true,
  },
  interactive: {
    emojis: true,
  },
  utilities: {
    clearFormatting: true,
  },
  mentions: {
    mentions: true,
  },
};

export const MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_IMAGE_SIZE_MB = 10;

export const fontOptions = [
  { value: "sans-serif", label: "Sans Serif" },
  { value: "serif", label: "Serif" },
  { value: "monospace", label: "Fixed Width" },
  { value: "arial black", label: "Wide" },
  { value: "arial narrow", label: "Narrow" },
  { value: "comic sans ms", label: "Comic Sans MS" },
  { value: "garamond", label: "Garamond" },
  { value: "georgia", label: "Georgia" },
  { value: "tahoma", label: "Tahoma" },
  { value: "trebuchet ms", label: "Trebuchet MS" },
  { value: "verdana", label: "Verdana" },
];

export const sizeOptions = [
  { value: "small", label: "Small", fontSize: "12px" },
  { value: "normal", label: "Normal", fontSize: "14px" },
  { value: "large", label: "Large", fontSize: "18px" },
  { value: "huge", label: "Huge", fontSize: "24px" },
];

export const listOptions = [
  { value: "bullet", icon: UnorderedListIcon },
  { value: "number", icon: NumberedListIcon },
];

export const alignOptions = [
  { value: "left", icon: AlignLeftIcon },
  { value: "center", icon: AlignCenterIcon },
  { value: "right", icon: AlignRightIcon },
];

export const formattingOptions = [
  {
    value: "remove",
    icon: RemoveStyleIcon,
    iconClassName:
      "w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk",
  },
  {
    value: "strike",
    icon: StrikeThroughIcon,
    iconClassName:
      "w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk",
  },
  {
    value: "quote",
    icon: QuoteIcon,
    iconClassName:
      "w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk",
  },
];
